module.exports = __webpack_public_path__ + "media/images/bread-302c8e57.jpg";